export const MODAL_ID = 'omni-sign-documnets-modal';
